define([
	"dojo/_base/declare",
	"csi/widget/RadioToggleButton",
	"./util",
	"./_Plugin",
	"dojo/text!./resources/Button.html",
], function(declare,RadioToggleButton,util,_Plugin,template) {

	return declare([RadioToggleButton, _Plugin], {
		bText: true,
		cssStyle: "verticalAlign",
		propertyKey: util.shapeProperties.verticalAlign,
		radioClass: "svgTextAlignVertical",
		templateString: template,
		
		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (this.bText && shapes && shapes.length) {
				this.set("checked", this.editor.canvasApp.selection.getCommonValue(shapes, this.propertyKey, true) === this.cssValue);
			}
			return this.inherited(arguments);
		},  

		/**
		 * Click event for Vertical Align buttons
		 * @param  {Event} e
		 */
		onClick: function(e) {
			const { editor } = this;

			// C8-26878 (Chrome scrolls parent element, in this case the canvasContainer or will fall back on pageContent when scrollTop !== 0)
			// Pressing any button in the right side menu will trigger a blur and subsequent re-focus event when editor is in EDIT_TEXT mode.
			// This is because this click event bubbles up to csi/widget/_svg/_Plugin.js, calling focus on the Froala Editor if the button is not "link".
			// In Chrome, if the element is focused before the render function in ShapeTextBody.tsx picks up the change in style, a parent element can scroll with the style change.
			// Other style changes (such as font size and paragraph format) have minimal effect on scrolling, since the text is not jumping drastically down or up.
			// Pre-setting this style avoids the scrolling since the focus will now happen after the style is already changed.
			// This also allows us to avoid putting a setTimeout on the re-focus, which was another way we could have avoided the scroll.
			const froalaInstance = editor.canvasApp.selection.getFroalaInstance();
			if (froalaInstance && froalaInstance.length) {
				// If there is a froalaInstance, we're in EDIT_TEXT mode.
				froalaInstance.$box[0].parentElement.style.justifyContent = this.cssValue;
			}
			editor.setTextStyle(this.cssStyle, this.cssValue, this.checked);
		}
	});
});
